import { Checkbox, Col, Form, Row, Table } from 'antd'
import { ReportsApi } from '../../../api/Corporates/Reports'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import useFetchList from '../../../elements/Hooks/useFetchList'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import { defaultFormItemLayout } from '../../../modules/FormItems'
import { dateFormat, moneyColumn, numVal } from '../../../modules/Utils'
import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'

Payable.propTypes = {}

function Payable(props) {
  const [company, setCompany] = React.useState([])
  // true : include Intercompany
  // false : Exclude Intercompany
  const [isIntercompany, setIsIntercompany] = React.useState(true)
  const [isIntraGroup, setIsInterGroup] = React.useState(false)

  const { list, fetch, fetching } = useFetchList(
    () => ReportsApi.payable({ company, isIntercompany, isIntraGroup }),
    [company, isIntercompany],
    undefined,
    undefined,
    { data: [], periods: [] }
  )

  let listData = list.data
  // if (!!list) {
  //   const centersCategory = _.groupBy(list.data, 'category')
  //   const keys = Object.keys(centersCategory)
  //   keys.forEach(key => {
  //     list.data.forEach(l => console.log(l.category === key, l.category, key))
  //
  //     const data = list.data.filter(l => l.category === key)
  //     listData.push({name: _.toUpper(key), style: 'strong', isHeader: true})
  //     data.forEach(d => listData.push(d))
  //   })
  // }
  const columns = [
    {
      title: <strong>Name</strong>,
      dataIndex: 'name',
      style: {
        textAlign: 'left',
        // marginLeft: '0.5rem',
      },
      render: (value, original) => {
        if (original._key)
          return (
            <Link target={'_blank'} to={`/purchasing/vouchers/${original._key}/update`}>
              {value}
            </Link>
          )

        return original.style ? (
          <strong
            style={{
              textTransform: 'uppercase',
              textAlign: 'left',
            }}>
            {original.category && `[${original.category}]`} {value}
          </strong>
        ) : (
          <span style={{ marginLeft: '1rem', fontSize: original.children && '1rem' }}>{value}</span>
        )
      },
    },
    {
      title: <strong>Status</strong>,
      dataIndex: 'status',
      style: {
        textAlign: 'left',
      },
      render: (value, original) => <StatusCell value={value} />,
    },
    {
      title: <strong>Date</strong>,
      dataIndex: 'date',
      style: {
        textAlign: 'left',
      },
      render: (value, original) => <span style={{ marginLeft: '1rem' }}>{value && dateFormat(moment(value))}</span>,
    },
    ...list.periods.map((r) => ({
      title: <strong>{r.name}</strong>,
      dataIndex: r.name,
      render: (value, original) =>
        value && (
          <span
            style={{
              fontSize: '1rem',
              textTransform: 'uppercase',
              textAlign: 'left',
              fontWeight: original.style && 'bold',
            }}>
            {value < 0
              ? `(${moneyColumn(numVal({ value: value * -1 }, 'value'))})`
              : moneyColumn(numVal({ value }, 'value'))}
          </span>
        ),
      headerStyle: {
        textAlign: 'right',
      },
      style: {
        textAlign: 'right',
      },
    })),
    {
      title: <strong>Total</strong>,
      dataIndex: 'total',
      style: {
        textAlign: 'right',
        fontSize: '1rem',
        textTransform: 'uppercase',
        fontWeight: 'bold',
      },
      render: (value, original) => (
        <strong
          style={{
            textAlign: 'right',
            fontSize: '1.2rem',
            textTransform: 'uppercase',
            fontWeight: 'bold',
          }}>
          {value && moneyColumn(numVal({ value }, 'value'))}
        </strong>
      ),
      // ),
    },
  ]

  return (
    <div style={{ overflowY: 'scroll' }}>
      <Row>
        <FormSectionTitle title={'Consolidated Payables Report (USD)'} />
        <RefreshButton onClick={fetch} />
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Filter By Company'}>
            <OrganisationsSelect
              value={company}
              onChange={(value) => setCompany(value)}
              mode="multiple"
              // style={{float: 'right', marginRight: '1rem', width: '100%'}}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Include Intercompany'}>
            <Checkbox defaultChecked={isIntercompany} onChange={(value) => setIsIntercompany(!value.target.checked)} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Include intragroup'}>
            <Checkbox defaultChecked={isIntraGroup} onChange={(value) => setIsInterGroup(!value.target.checked)} />
          </Form.Item>
        </Col>
      </Row>
      <Table pagination={{ pageSize: 50 }} loading={fetching} columns={columns} dataSource={listData} rowKey={'name'} />
    </div>
  )
}

export default Payable
